module.exports = __webpack_public_path__ + "static/media/Avatars_Female-09.c71091db.png";